import { render, staticRenderFns } from "./DiaobodanEditForm.vue?vue&type=template&id=f6de871a&scoped=true&"
import script from "./DiaobodanEditForm.vue?vue&type=script&lang=js&"
export * from "./DiaobodanEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6de871a",
  null
  
)

export default component.exports